import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, icon = "solar:home-smile-angle-outline", actionTo, actionLabel = "Voltar para consulta" }) => {
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
      <h6 className='fw-semibold mb-0 d-flex align-items-center gap-2'>
        <Icon icon={icon} className='icon text-xl text-primary-600' />
        {title}
      </h6>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        {actionTo && (
          <Link
            to={actionTo}
            className='btn btn-outline-primary-600 text-sm d-inline-flex align-items-center gap-8'
          >
            <Icon icon='solar:arrow-left-outline' className='text-lg' />
            {actionLabel}
          </Link>
        )}
        <ul className='d-flex align-items-center gap-2 mb-0'>
          <li className='fw-medium'>
            <Link
              to='/dashboard'
              className='d-flex align-items-center gap-1 hover-text-primary'
            >
              <Icon
                icon='solar:home-smile-angle-outline'
                className='icon text-lg'
              />
              Dashboard
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Breadcrumb;
